export const DemandSources = {
  acuity: 'acuity',
  admixer: 'admixer',
  amazonORTB: 'amazonORTB',
  apsGuarantee: 'apsGuarantee',
  apsOpenAuction: 'apsOpenAuction',
  apsPMP: 'apsPMP',
  appnexus: 'appnexus',
  beachfront: 'beachfront',
  cadent: 'cadent',
  column6: 'column6',
  connatix: 'connatix',
  consumable: 'consumable',
  conversant: 'conversant',
  criteo: 'criteo',
  dynamicGateway: 'dynamicGateway',
  dynamicPlatformConnection: 'dynamicPlatformConnection',
  elementaltv: 'elementaltv',
  epsilon: 'epsilon',
  finecast: 'finecast',
  freewheel: 'freewheel',
  freewheelssp: 'freewheelssp',
  gateway: 'gateway',
  gatewayTier0: 'gatewayTier0',
  gumgum: 'gumgum',
  improvedigital: 'improvedigital',
  indexExchange: 'indexExchange',
  inmobi: 'inmobi',
  iponweb: 'iponweb',
  krush: 'krush',
  madhive: 'madhive',
  magnite: 'magnite',
  magnitectv: 'magnitectv',
  marketingarchitects: 'marketingarchitects',
  medianet: 'medianet',
  mezzo: 'mezzo',
  mobilefuse: 'mobilefuse',
  motiv: 'motiv',
  nativeVast: 'nativeVast',
  nexstar: 'nexstar',
  nhnace: 'nhnace',
  nobid: 'nobid',
  openx: 'openx',
  origin: 'origin',
  platformConnection: 'platformConnection',
  premion: 'premion',
  publica: 'publica',
  publicaCampaign: 'publicaCampaign',
  pubmatic: 'pubmatic',
  pulsepoint: 'pulsepoint',
  rhythmone: 'rhythmone',
  rokuHB: 'rokuHB',
  rokuORTB: 'rokuORTB',
  rubicon: 'rubicon',
  sabio: 'sabio',
  samsungAdManager: 'samsungAdManager',
  samsungDSP: 'samsungDSP',
  samsungssp: 'samsungssp',
  samsungssptest: 'samsungssptest',
  sharethrough: 'sharethrough',
  smaato: 'smaato',
  smart: 'smart',
  smartadserver: 'smartadserver',
  smartclip: 'smartclip',
  smartstream: 'smartstream',
  smartyads: 'smartyads',
  sonobi: 'sonobi',
  sovrn: 'sovrn',
  stroer: 'stroer',
  tappx: 'tappx',
  teads: 'teads',
  telaria: 'telaria',
  thetradedesk: 'thetradedesk',
  theviewpoint: 'theviewpoint',
  triplelift: 'triplelift',
  trustx: 'trustx',
  undertone: 'undertone',
  unruly: 'unruly',
  verizon: 'verizon',
  vibe: 'vibe',
  videobyte: 'videobyte',
  videoHeroesFixedCPM: 'videoHeroesFixedCPM',
  videoHeroesRevShare: 'videoHeroesRevShare',
  vrtcal: 'vrtcal',
  wurl: 'wurl',
  xandr: 'xandr',
  yahoo: 'yahoo',
  yieldmo: 'yieldmo',
  zedo: 'zedo',
} as const;

export type DemandSource = (typeof DemandSources)[keyof typeof DemandSources];
